import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    curso_escolar_id: Yup.string().required('El curso escolar es obligatorio'),
    colegio_id:       Yup.string().required('El colegio es obligatorio'),
    mes:              Yup.string().required('El mes es obligatorio'),
})